import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModalInpageSkin extends Component {
  static displayName = 'ModalInpageSkin';

  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  render() {
    return (
      <div>
        <div className="modal-title">Comments Color Scheme</div>
        <div className="figures">
          <div className="figure">
            <img src="https://publisher-assets.spot.im/host-panel/inpage-skin-light.png" />
            <span className="label">Light</span>
          </div>
          <div className="figure">
            <img src="https://publisher-assets.spot.im/host-panel/inpage-skin-dark.png" />
            <span className="label">Dark</span>
          </div>
        </div>
        <div className="button-container">
          <div className="confirm-button" onClick={this.props.onClose}>
            Got it!
          </div>
        </div>
      </div>
    );
  }
}

export default ModalInpageSkin;
